import Home from "@landingClient/pages/Home";
import { AuthTab, ModalType, openModal } from "@landingClient/store/modalSlice";
import {
  createFileRoute,
  useNavigate,
  useSearch,
} from "@tanstack/react-router";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import * as Sentry from "@sentry/react";

export const Route = createFileRoute("/login")({
  component: RouteComponent,
  validateSearch: (search) => ({
    acceptInvite: search.acceptInvite ? String(search.acceptInvite) : undefined,
  }),
});

function RouteComponent() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { acceptInvite } = useSearch({ from: "/login" });

  useEffect(() => {
    let username: string | undefined, password: string | undefined;

    if (acceptInvite) {
      navigate({
        to: ".",
        search: {},
        replace: false,
      });
      try {
        const { username: inviteDataUsername, password: inviteDataPassword } =
          JSON.parse(atob(decodeURIComponent(acceptInvite)));
        username = inviteDataUsername;
        password = inviteDataPassword;
      } catch (error) {
        console.error("Error parsing acceptInvite data:", error);
        Sentry.captureException(error, {
          extra: { acceptInvite },
          tags: { feature: "invite-login" },
        });
      }
    }

    dispatch(
      openModal({
        modal: ModalType.Auth,
        params: {
          defaultTab: AuthTab.Login,
          defaultUsername: username,
          defaultPassword: password,
        },
      }),
    );
  }, [acceptInvite]);

  return <Home />;
}
